function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4356 19.1254L18.9326 16.6078C18.8319 16.054 18.5301 15.5505 18.0773 15.198C17.8007 14.9715 17.524 14.8204 17.2473 14.7701L15.1092 14.1407C15.0589 14.1155 15.0086 14.1155 14.9835 14.0903C14.8829 14.0148 14.8074 13.8889 14.7823 13.7631L14.6816 12.9071C15.2853 12.4288 15.7381 11.7491 15.9393 10.9183C16.3166 10.8931 16.6184 10.4651 16.6184 9.91127C16.6184 9.40777 16.3669 9.00497 16.0148 8.92944",
  stroke: "#1C6BBA",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.97871 8.90479C9.65172 9.00549 9.40018 9.40829 9.40018 9.88661C9.40018 10.4153 9.70202 10.8433 10.0793 10.8936C10.3057 11.6992 10.7333 12.4041 11.337 12.8824L11.2364 13.7132C11.2112 13.8391 11.1358 13.965 11.0352 14.0405C10.9848 14.0657 10.9597 14.0909 10.9094 14.0909L8.77135 14.7202C8.49466 14.7706 8.21798 14.9216 7.94129 15.1482C7.51368 15.5007 7.21184 16.0042 7.08607 16.558L6.58301 19.0755",
  stroke: "#1C6BBA",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0152 8.90467C16.0152 8.90467 16.1913 5.35498 12.9968 5.35498C9.80235 5.35498 9.95327 8.92984 9.95327 8.92984",
  stroke: "#1C6BBA",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2051 7.3942C10.3308 7.14244 10.5824 6.94104 10.8339 6.84034C11.2615 6.68929 11.7646 6.81517 12.167 6.99139C12.7707 7.26832 13.2989 7.5956 13.9781 7.67112C14.6321 7.74665 15.2106 7.67112 15.7891 7.36902",
  stroke: "#1C6BBA",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0352 14.0657L12.9971 16.1049",
  stroke: "#1C6BBA",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9832 14.0657L12.9961 16.1049",
  stroke: "#1C6BBA",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9961 16.1047V17.4642",
  stroke: "#1C6BBA",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9972 25.0151C19.623 25.0151 24.9943 19.6391 24.9943 13.0075C24.9943 6.37595 19.623 1 12.9972 1C6.37131 1 1 6.37595 1 13.0075C1 19.6391 6.37131 25.0151 12.9972 25.0151Z",
  stroke: "#1C6BBA",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3242 27.1044C20.9199 27.1044 27.082 20.937 27.082 13.3347",
  stroke: "#1C6BBA",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1144 21.8684L30.5285 28.2881C31.1573 28.9174 31.1573 29.9244 30.5285 30.5286C29.8997 31.158 28.8935 31.158 28.2898 30.5286L21.8506 24.1342",
  stroke: "#1C6BBA",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgInfoShortIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoShortIcon4);
export default __webpack_public_path__ + "static/media/info-short-icon4.e8dbb20c.svg";
export { ForwardRef as ReactComponent };